import { useEffect, useState } from "react"
import { Ideas } from "../../components/ideas/ideas.component"
import { NoIdeaFound } from "../../components/noIdeaFound/noIdeaFound.component"
import { getMyIdeas } from "../../services/ideas.service"

export const MyIdeasList = () => {
    const [feeds, setFeeds] = useState([])

    const getData = async () => {
        const { status, data } = await getMyIdeas()
        if (status == 200) {
            setFeeds(data);
        }
    };
    useEffect(() => {
        getData()
    }, [])
    return (
        <>
            <h2>MY POSTS</h2>
            {feeds.length ? feeds.map((data) => {
                // console.log(data)
                const underReview = (data.STATUS == "In Review" || data.STATUS == "New") ? true : false
                return <Ideas
                    key={data.IDEA_ID}
                    ideaId={data.IDEA_ID}
                    Name={data.EMP_NAME}
                    Desc={data.IDEA_DETAIL}
                    CreatedAt={data.createdAt}
                    Attachments={data.attachments}
                    hearts={data.hearts}
                    likes={data.likes}
                    dislikes={data.dislikes}
                    comments={data.comments}
                    reactionId={data.reactionId}
                    reactionType={data.reactionType}
                    underReview={underReview}
                />
            }) : <NoIdeaFound heading={"You have not post any idea yet."}/>}
        </>
    )
}